<template>
    <div ref="accountView">
        <div class="shopopee-title">
            <span class="part-1">Shop</span>
            <span class="part-2">opee</span>
        </div>
        <div class="account-container">
            <ul class="account-info-inpus">
                <li class="col-9-li">
                    <span tkey="登錄賬戶">{{i18n.tkey("lang_login_in")}}</span>：{{userinfoRef.login}}
                </li>

                <li class="col-9-li">
                    <span tkey="姓名">{{i18n.tkey("lang_name")}}</span>：{{userinfoRef.name}}
                </li>

                <li class="col-9-li">
                    <span tkey="性別">{{i18n.tkey("lang_sex")}}</span>：
                    <el-select v-model="userinfoRef.modelSex" @change="changePersonSex" class="m-2" :placeholder="i18n.tkey('lang_sex')" size="large">
                        <el-option
                                :key="0"
                                :label="i18n.tkey('lang_male')"
                                :value="0"
                        />

                        <el-option
                                :key="1"
                                :label="i18n.tkey('lang_female')"
                                :value="1"
                        />
                    </el-select>
                </li>

                <li class="col-9-li">
                    <span tkey="店員性別">{{i18n.tkey("lang_shopman_sex")}}</span>：
                    <el-select v-model="userinfoRef.shopmanSex" @change="changeShopmanSex" class="m-2" :placeholder="i18n.tkey('lang_shopman_sex')" size="large">
                        <el-option
                                :key="null"
                                :label="i18n.tkey('lang_no_setting')"
                                :value="null"
                        />

                        <el-option
                                :key="0"
                                :label="i18n.tkey('lang_male')"
                                :value="0"
                        />

                        <el-option
                                :key="1"
                                :label="i18n.tkey('lang_female')"
                                :value="1"
                        />
                    </el-select>
                </li>

                <li class="col-9-li" style="text-align: center; margin-top: 30px">
                    <el-button size="large" type="danger" @click="logoutFunc" tkey="退出登錄">{{i18n.tkey('lang_log_out_2')}}</el-button>
                </li>
            </ul>
        </div>
    </div>
</template>

<script setup>
    import {getCurrentInstance, onMounted, toRef, inject} from 'vue'
    import { useUserinfo } from '@/stores/userinfo'
    import { ElMessage, ElMessageBox } from 'element-plus'
    import cookie from "@/util/cookie";

    const emits = defineEmits(['logout-complete'])

    let { proxy } = getCurrentInstance();
    let Axios = proxy.$Axios;
    const userinfo = useUserinfo()
    const userinfoRef = toRef(userinfo)

    const { changePersonModel } = inject('threeCityFunc', { changePersonModel: () => {} })

    const i18n = inject("i18n")

    function logoutFunc(){
        ElMessageBox.confirm('確定要退出登錄嗎？', {
            confirmButtonText: "確定",
            cancelButtonText: "取消",
        })
        .then(() => {
            logoutAccount()

            emits("logout-complete")

            ElMessage({
                showClose: true,
                message: '已退出登錄',
                type: 'success',
            })


        })
        .catch(() => {
            // catch error
        })
    }

    function changePersonSex(){

        changePersonModel()

        // ElMessageBox.confirm('修改角色性別需要重新加載頁面後才會生效，現在是否重新加載？', {
        //     confirmButtonText: "確定",
        //     cancelButtonText: "取消",
        // })
        // .then(() => {
        //     // location.reload()
        //     window.location.reload(true)
        // })
        // .catch(() => {
        //     // catch error
        // })
    }

    function changeShopmanSex() {
        ElMessageBox.confirm('修改店員性別需要重新加載頁面後才會生效，現在是否重新加載？', {
            confirmButtonText: "確定",
            cancelButtonText: "取消",
        })
        .then(() => {
            // location.reload()
            window.location.reload(true)
        })
        .catch(() => {
            // catch error
        })
    }

    //退出登錄方法
    function logoutAccount(){
        const obj = cookie.getCookie()

        for (const key in obj){
            cookie.removeCookie(key)
            cookie.removeCookie(key, {path: '/'})
        }

        const invCode = userinfoRef.value.invCode

        const lang = userinfoRef.value.lang

        const positionX = userinfoRef.value.positionX
        const positionZ = userinfoRef.value.positionZ
        const selectCountry = userinfoRef.value.selectCountry

        userinfoRef.value.$reset()

        userinfoRef.value.lang = lang

        userinfoRef.value.invCode = invCode

        userinfoRef.value.positionX = positionX
        userinfoRef.value.positionZ = positionZ
        userinfoRef.value.selectCountry = selectCountry

    }

    onMounted(()=>{

    })
</script>

<style scoped>
    ul {
        list-style: none;
        margin: 0;
        padding-left: 0;
    }

    .shopopee-title {
        font-size: 44px;
        text-align: center;
        font-weight: 700;
        margin-top: 10px;
        margin-bottom: 10px;
    }

    .shopopee-title .part-1 {
        color: #8400FF;
    }

    .shopopee-title .part-2 {
        color: #02A7F0;
    }

    .account-info-inpus {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        justify-content: center;
        text-align: left;
        line-height: 3;
        margin-top: 30px;
    }

    .col-9-li {
        width: 75%;
    }
</style>